
<div class="w-full p-4">
	<div class="flex items-center justify-between w-full">
		<div class="flex justify-start items-center">
			<img src="img/07.svg" alt="SvelteKit" class="w-1/2 pr-2 pb-2"/>
			<!-- <p class="font-light text-xl">Eyeglasses</p> -->
		</div>
		<div class="flex w-3/4 justify-end pt-4">
			<div class="flex items-center justify-start border w-3/4 border-gray-400 rounded-sm p-1">
				Search frame, model, or brand
			</div>
			<div class="bg-orange-600 text-white w-36 flex items-center justify-center cursor-pointer ml-2">Search</div>
		</div>
	</div>
	<hr class="my-2"/>
	<div class="flex items-center justify-between">
		<div>
			<span class="p-2 m-2">Men</span>
			<span class="p-2 m-2">Women</span>
			<span class="p-2 m-2">Glasses</span>
			<span class="p-2 m-2">Lenses</span>
			<span class="p-2 m-2">Sunglasses</span>
		</div>
		<img src="img/cart.svg" class="text-lg text-gray-700" alt="cart"/>
	</div>
	<hr class="mt-2"/>
</div>



